import app from 'flarum/common/app';
export function getYearRenderMode(year) {
  if (!year) return 'slideshow';
  try {
    const raw = app.forum.attribute('rewindYearRenderModes') || '{}';
    const map = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (map && typeof map === 'object' && map[String(year)]) {
      return map[String(year)];
    }
  } catch {
    // fallback
  }
  return 'slideshow';
}
flarum.reg.add('huseyinfiliz-rewind', 'common/utils/getYearRenderMode', { getYearRenderMode: getYearRenderMode, });